export default __webpack_public_path__ + "e8812f1fcb77c6123b4efc7ddf4dfad9.png";